import React from 'react';
import ReactDOM from 'react-dom';
import './index.module.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "@app/common/store/store";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
const THEME = createMuiTheme({
    typography: {
        //fontFamily: '"Betons", "Arial", "Hetica", sans-serif',
        fontFamily:'"Montserrat",sans-serif',
        fontSize: 12,
    },
});
ReactDOM.render(
    <React.StrictMode>
        <MuiThemeProvider theme={THEME}>
            <Provider store={store}>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    {/*<Authentication>*/}
                        <App />
                    {/*</Authentication>*/}
                </BrowserRouter>
            </Provider>
        </MuiThemeProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
